module.exports = __WEBPACK_EXTERNAL_MODULE__innovyze_stylovyze_lib_hooks_map_useReactMapConfig__;